import { useCallback } from "react";
import { Canvas } from "@react-three/fiber";
import * as THREE from "three";
import { CONFIG } from "../config";
import {
  ControlsCanvasBridge,
  ControlsContextBridge,
} from "./controls/controls-provider";

type SceneCanvasProps = {
  onReady?: (context: {
    renderer: THREE.WebGLRenderer;
    scene: THREE.Scene;
    camera: THREE.Camera;
  }) => void;
};

export const SceneCanvas = ({ onReady }: SceneCanvasProps) => {
  const handleCreated = useCallback(
    (state: {
      gl: THREE.WebGLRenderer;
      scene: THREE.Scene;
      camera: THREE.Camera;
    }) => {
      state.gl.domElement.id = state.gl.domElement.id || "canvas";
      if (typeof onReady === "function") {
        onReady({
          renderer: state.gl,
          scene: state.scene,
          camera: state.camera,
        });
      }
    },
    [onReady]
  );

  return (
    <Canvas
      onCreated={handleCreated}
      frameloop="always"
      gl={{
        antialias: CONFIG.ANTIALIAS,
        powerPreference: CONFIG.POWER_PREFERENCE,
      }}
      dpr={CONFIG.PIXEL_RATIO}
    >
      <ControlsContextBridge>
        <ControlsCanvasBridge />
      </ControlsContextBridge>
    </Canvas>
  );
};
